import { useState } from 'react'
import { useAnalyticsTrack } from '@/features/amplitude'
import { CardColors, HeroCard, Text } from '@/ui'
import { ImageBackgroundColors, TypographyStyles } from '@/styles'

const NEW_ON_HOMEPAGE_BANNER_KEY =
  'NEW_ON_HOMEPAGE_BANNER_KEY_MAXIMIZE_TAX_DEDUCTIONS'

export const NewOnHomepageBanner = () => {
  const track = useAnalyticsTrack()
  const [noticeDismissed, setNoticeDismissed] = useState(
    localStorage.getItem(NEW_ON_HOMEPAGE_BANNER_KEY) === 'true'
  )

  if (noticeDismissed) {
    return null
  }

  const handleClose = () => {
    track("clicked dismiss what's new banner")
    localStorage.setItem(NEW_ON_HOMEPAGE_BANNER_KEY, 'true')
    setNoticeDismissed(true)
  }

  return (
    <HeroCard
      color={CardColors.EMPHASIS}
      imageAlt="Sparkling house"
      imageSrc="https://heard-images.s3.amazonaws.com/assets/home-sparkles.svg"
      imageColor={ImageBackgroundColors.ORANGE}
      imageWidth={160}
      onClose={handleClose}
      title="What's new on the Home page"
    >
      <Text variant={TypographyStyles.BODY_MD} className="mt-[-14px]">
        Check out <strong>Maximize Tax Deductions</strong>, which tracks your
        year-to-date tax savings from business expense deductions and offers
        tips on how to lower your tax liability. Stay tuned for upcoming
        enhancements featuring more personalized insights and reporting.
      </Text>
    </HeroCard>
  )
}
